import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL
})
instance.defaults.withCredentials = true

instance.interceptors.response.use(
  response => {
    return response
  },

  error => {
    // On failure, let remote error message override local one.
    if (error.response.data.message) {
      error.message = error.response.data.message
    }
    return Promise.reject(error)
  }
)

export default instance
